import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatFileName',
  pure: true,
})
export class FormatFileNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    // 1) strip off the extension (.pdf, .docx, etc.)
    const withoutExt = value.replace(/\.[^/.]+$/, '');
    // 2) replace all underscores with spaces
    return withoutExt.replace(/_/g, ' ');
  }
}
